import ProgramOverviewFormContainer from './program_overview_form_container';

const ProgramOverviewForm = ProgramOverviewFormContainer;
export default ProgramOverviewForm;
